import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PageHeadComponent } from '@component/page-head/page-head.component';
import { CardProjectComponent } from "@component/card-project/card-project.component";
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BtnLoaderModule } from './btnloader.module';
import { MaterialModule } from './material.module';
import { NicknamePipeModule } from './nickname-pipe.module';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgbModule,
    MaterialModule,
    BtnLoaderModule,
    NicknamePipeModule,
  ],
  declarations: [
    PageHeadComponent,
    CardProjectComponent
  ],
  exports: [
    PageHeadComponent,
    CardProjectComponent
  ],
  entryComponents: [
  ],
  providers: []
})
export class SharedModule { }
